/**
 * Styled components shared by Create, Reset, Restore components
 */
import { StandardModalInput, StandardModalLabel, portalColors } from "src/components";
import styled from "styled-components";

export const Content = styled.div`
    display: grid;
    gap: 1rem;
    width: 100%;
    max-width: 42rem;
    margin: 0 auto;
`;

export const TextLabel = StandardModalLabel;

export const StyledInput = styled(StandardModalInput)`
    width: min(100%, 324px);
    margin: 8px 0 18px 0;
`;

export const SubText = styled.div`
    width: 100%;
    max-width: 324px;
    text-align: center;
    font-size: 13px;
    color: ${portalColors.mutedText};
`;
